export class GpsMap {
	id: string;
	deviceId: string;
	locationId: string;
	data: any = {};
	frequency: number;
	timestamp: Date;
	rssi: number;
	lsnr: number;
}

